import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";

import Landing from "./views/Landing.vue";
import Residences from "./views/Residences.vue";
import Contact from "./views/Contact.vue";
import Blogs from "./views/Blogs.vue";
import DetailsBlog from "./views/DetailsBlog.vue";
import CategoryPosts from "./views/CategoryPosts.vue";
import TagPosts from "./views/TagPosts.vue";
import Aboutus from "./views/Aboutus.vue";
import Projects from "./views/Projects.vue";
import Services from "./views/Services.vue";
import Components from "./views/Components.vue";
import Heagle from "./views/Heagle.vue";
import Maname from "./views/Maname.vue";
import Totiateb from "./views/Totiateb.vue";
import Products from "./views/Products.vue";
import SatrApp from "./views/SatrApp.vue";
import CRM from "./views/CRM.vue";
import Reservation from "./views/Reservation.vue";
import Scientometrics from "./views/Scientometrics.vue";
import Onlion from "./views/Onlion.vue";
import SatrAppLms from "./views/SatrAppLms.vue";

import Register from "./views/Register.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter,
      },
    },
    {
      path: "/services",
      name: "Services",
      components: {
        header: AppHeader,
        default: Services,
        footer: AppFooter,
      },
    },
    {
      path: "/components",
      name: "Components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter,
      },
    },
    {
      path: "/projects",
      name: "projects",
      components: {
        header: AppHeader,
        default: Projects,
        footer: AppFooter,
      },
    },
    {
      path: "/residences",
      name: "residences",
      components: {
        header: AppHeader,
        default: Residences,
        footer: AppFooter,
      },
    },
    {
      path: "/heagle",
      name: "Heagle",
      components: {
        header: AppHeader,
        default: Heagle,
        footer: AppFooter,
      },
    },
    {
      path: "/manamed",
      name: "Maname",
      components: {
        header: AppHeader,
        default: Maname,
        footer: AppFooter,
      },
    },

    // {
    //   path: "/jobs",
    //   name: "jobs",
    //   components: {
    //     header: AppHeader,
    //     default: Jobs,
    //     footer: AppFooter,
    //   },
    // },
    // {
    //   path: "/jobs/id",
    //   name: "jobs",
    //   components: {
    //     header: AppHeader,
    //     default: JobsID,
    //     footer: AppFooter,
    //   },
    // },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter,
      },
    },

    {
      path: "/products",
      name: "Products",
      components: {
        header: AppHeader,
        default: Products,
        footer: AppFooter,
      },
    },
    {
      path: "/satrapp",
      name: "SatrApp",
      components: {
        header: AppHeader,
        default: SatrApp,
        footer: AppFooter,
      },
    },
    {
      path: "/crm",
      name: "CRM",
      components: {
        header: AppHeader,
        default: CRM,
        footer: AppFooter,
      },
    },
    {
      path: "/reservation",
      name: "Reservation",
      components: {
        header: AppHeader,
        default: Reservation,
        footer: AppFooter,
      },
    },
    {
      path: "/onlion",
      name: "Onlion",
      components: {
        header: AppHeader,
        default: Onlion,
        footer: AppFooter,
      },
    },
    {
      path: "/scientometrics",
      name: "Scientometrics",
      components: {
        header: AppHeader,
        default: Scientometrics,
        footer: AppFooter,
      },
    },
    {
      path: "/satrapp-lms",
      name: "SatrAppLms",
      components: {
        header: AppHeader,
        default: SatrAppLms,
        footer: AppFooter,
      },
    },
    {
      path: "/totiateb",
      name: "Totiateb",
      components: {
        header: AppHeader,
        default: Totiateb,
        footer: AppFooter,
      },
    },

    {
      path: "/blogs",
      name: "Blogs",
      components: {
        header: AppHeader,
        default: Blogs,
        footer: AppFooter,
      },
    },
    {
      path: "/blog/:id/:title",
      name: "DetailsBlog",
      components: {
        header: AppHeader,
        default: DetailsBlog,
        footer: AppFooter,
      },
    },
    {
      path: "/blog/tag/:tagName",
      name: "TagPosts",
      components: {
        header: AppHeader,
        default: TagPosts,
        footer: AppFooter,
      },
    },
    {
      path: "/blog/category/:categoryId",
      name: "CategoryPosts",
      components: {
        header: AppHeader,
        default: CategoryPosts,
        footer: AppFooter,
      },
    },
    {
      path: "/contact-us",
      name: "Contact",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter,
      },
    },
    {
      path: "/about-us",
      name: "Aboutus",
      components: {
        header: AppHeader,
        default: Aboutus,
        footer: AppFooter,
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
